import { render, staticRenderFns } from "./CustomerCenterEdit.vue?vue&type=template&id=55fda600&scoped=true"
import script from "./CustomerCenterEdit.vue?vue&type=script&lang=js"
export * from "./CustomerCenterEdit.vue?vue&type=script&lang=js"
import style0 from "./CustomerCenterEdit.vue?vue&type=style&index=0&id=55fda600&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fda600",
  null
  
)

export default component.exports